import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";

export const PointsDialog = ({ open, onOpenChange, customer, onDone }) => {
  const [points, setPoints] = useState("");
  const [reason, setReason] = useState("");
  const [mode, setMode] = useState("add");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    const n = parseInt(points, 10);
    if (!n || n < 0 || !reason.trim()) return toast.error("Inserisci punti e causale");
    setBusy(true);
    try {
      await api.post(`/customers/${customer.id}/points`, { points: mode === "add" ? n : -n, reason });
      toast.success(mode === "add" ? `${n} punti assegnati` : `${n} punti rimossi`);
      setPoints(""); setReason("");
      onOpenChange(false);
      onDone?.();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white" data-testid="points-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Gestisci punti · {customer?.name}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-2 rounded-lg bg-slate-100 p-1">
            {[["add", "Assegna"], ["remove", "Rimuovi"]].map(([k, l]) => (
              <button key={k} data-testid={`points-mode-${k}`} onClick={() => setMode(k)}
                className={`rounded-md py-1.5 text-sm font-medium transition-colors ${mode === k ? "bg-white text-slate-900 shadow-sm" : "text-slate-500"}`}>
                {l}
              </button>
            ))}
          </div>
          <div className="space-y-1.5">
            <Label>Punti</Label>
            <Input data-testid="points-amount-input" type="number" min="1" value={points} onChange={(e) => setPoints(e.target.value)} />
          </div>
          <div className="space-y-1.5">
            <Label>Causale</Label>
            <Input data-testid="points-reason-input" value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Es. Bonus compleanno" />
          </div>
        </div>
        <DialogFooter>
          <Button data-testid="points-submit-button" onClick={submit} disabled={busy} className="bg-blue-600 hover:bg-blue-700">
            {busy ? "Salvataggio..." : "Conferma"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
